import { handling as handlingApi } from '@afosto/fulfilment/api/Handling';
import { shipments as shipmentsApi } from '@afosto/fulfilment/api/Shipments';

export const createHandlingList = async shipment => {
  try {
    let dueAt = shipment?.ship_at ? new Date(shipment.ship_at) : null;

    if (!shipment?.is_outbound) {
      dueAt = shipment?.expected_at ? new Date(shipment.expected_at) : null;
    }

    await shipmentsApi.updateShipmentPositions(shipment?.id).catch(() => {
      // Do nothing.
    });

    const response = await handlingApi.createHandlingList({
      shipments: [{ id: shipment?.id }],
      due_at: dueAt,
    });
    const { data = null } = response;

    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

/**
 * Create a handling list for the current shipment and start picking
 * @returns {Promise}
 */
export const startPicking = async ({ shipment, handlingListID, history, pack = false }) => {
  if (handlingListID) {
    history.push(`/handling-lists/${handlingListID}/process${pack ? '/pack' : ''}`);
    return;
  }

  const handlingList = await createHandlingList(shipment);
  history.push(`/handling-lists/${handlingList?.id}/process${pack ? '/pack' : ''}`);
};

/**
 * Create a handling list for the current shipment and start picking
 * @returns {Promise}
 */
export const startPlacing = async ({ shipment, handlingListID, history }) => {
  if (handlingListID) {
    history.push(`/handling-lists/${handlingListID}/process`);
    return;
  }

  const handlingList = await createHandlingList(shipment);
  history.push(`/handling-lists/${handlingList.id}/process`);
};
